import kpn from './assets/kpn-logo.svg';

function Header() {
  return (
    <header>
      <h1>Welkom bij installatie helper</h1>
      <p>
        Doormiddel van het aanklikken van de vragen wordt je door je installatie
        begeleid.
      </p>
      {/* <img className='logo' src={kpn} alt='KPN Logo' /> */}
    </header>
  );
}

export default Header;
